import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReferenceDataLabels } from '../../constants/reference-data-labels';
import { SavableFilter } from '../../models/dto';

@Component({
  selector: 'boi-saved-searches',
  templateUrl: './saved-searches.component.html',
  styleUrls: ['./saved-searches.component.scss']
})
export class SavedSearchesComponent {
  @Input() public savedSearches: Array<SavableFilter>;
  @Output() public readonly applySearchEmitter = new EventEmitter<SavableFilter>();
  @Output() public readonly deleteSearchEmitter = new EventEmitter<SavableFilter>();
  public referenceDataLabels = ReferenceDataLabels;
  public isDeleteSearchConfirmationDialogOpened = false;
  public searchForDeletion: SavableFilter;
  public savedSearchesNameSeparator = '|';
}
